import React from "react";
import { default as MUIInput } from "@mui/material/Input";
import styled from "styled-components";

const StyledMUIInput = styled(MUIInput)`
  &::before {
    content: unset !important;
  }

  &::after {
    content: unset !important;
  }

  input:focus {
    border: 2px solid var(--primaryColor) !important;
  }
`;

/**
 * @deprecated - use TextField-component
 */

export const Input = (props) => {
  return <StyledMUIInput {...props} />;
};
